export default __webpack_public_path__ + "static/media/64.c5e970f1.jpeg";